<template>
  <div class="home">
    <div class="ym_header" @mouseenter="showCarouselButtons = true" @mouseleave="showCarouselButtons = false">
      <div class="layui-fluid" style="padding:0;">
        <div class="layui-row">
          <div class="layui-col-sm12 layui-col-md12">
            <div class="layui-card">
              <div class="layui-carousel">
                <div class="carousel-item">
                  <div v-for="(image, index) in carouselImages" :key="index"
                    :class="{ active: index === currentImageIndex }">
                    <img class="img" :src="image" />
                  </div>
                </div>
                <div v-show="showCarouselButtons" class="carousel-controls">
                  <button class="carousel-btn carousel-btn-prev" @click="prevImage">
                    <span>‹</span>
                  </button>
                  <button class="carousel-btn carousel-btn-next" @click="nextImage">
                    <span>›</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ym_layout">
        <router-link to="/" class="ym_logo" style="z-index: 1000;">
          <img src="/static/img/logo.png" width="106">
        </router-link>

        <div class="ym_slogan">
          <div>
            <span class="ym_slogan_text" v-html="sloganText"></span>
          </div>
        </div>

        <div class="ym_menu">
          <ul>
            <li v-for="(item, index) in menuItems" :key="index" @mouseover="showSubMenu(index)"
              @mouseout="hideSubMenu(index)">
              <router-link class="m" :to="item.path">{{ item.name }}</router-link>
              <router-link v-for="subItem in item.subMenus" :key="subItem.name" :to="subItem.path" class="childls">{{
                subItem.name }}</router-link>
            </li>
          </ul>
        </div>

        <div class="ym_system">
          <a class="ym_system_name" href="/serveList?type=WSLAXT">在线立案</a>
          <div class="ym_case" ref="caseBtn" @click.stop="toggleCaseMenu">
            <a class="ym_system_name ym_case_trigger" href="javascript:;" @click.prevent>案件公示</a>
            <transition name="ym_case_fade">
              <div v-show="showCaseMenu" class="ym_case_dropdown">
                <a v-for="item in casePublicityItems" :key="item.name" class="ym_case_item" :href="item.url"
                  target="_blank" rel="noopener noreferrer">{{ item.name }}</a>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="ym_main ym_mt20">
      <div class="ym_news">
        <div class="ym_layout">
          <div class="ym_news_slide">
            <div class="swiper-container ym_swiper-container">
              <div class="swiper-wrapper">
                <div v-for="(slide, index) in newsSlides" :key="index" class="swiper-slide" :style="{ display: index === currentNewsIndex ? 'flex' : 'none' }">
                  <img :src="slide" />
                </div>
              </div>
              <div class="swiper-pagination ym_swiper-pagination"></div>
            </div>
          </div>

          <div class="ym_news_tab_box ym_rt" style="width: 588px;">
            <div class="ym_tab_title tabs-title">
              <ul>
                <li :class="{ on: activeTab === 0 }" @click="switchTab(0)">
                  <a href="javascript:;">双仲动态</a>
                </li>
                <li :class="{ on: activeTab === 1 }" @click="switchTab(1)">
                  <a href="javascript:;">通知公告</a>
                </li>
              </ul>
              <span class="more" style="margin-top: 16px;">
                <a href="/dynamiList">
<!--                  <span class="icon iconfont icon-gengduo ym_more_icon"></span>-->
                  <img src="/static/img/more.png" style="width: 22px;height: 22px;display: block">
                </a>
              </span>
            </div>
            <div class="ym_list ym_list-date ym_tabs-list">
              <ul v-show="activeTab === 0">
                <li v-for="article in szdtArticles" :key="article.id">
                  <router-link :to="`/detail?id=${article.id}`">{{ article.title }}</router-link>
                  <span class="date">{{ article.publishDate }}</span>
                </li>
              </ul>
              <ul v-show="activeTab === 1">
                <li v-for="article in tzggArticles" :key="article.id">
                  <router-link :to="`/detail?id=${article.id}`">{{ article.title }}</router-link>
                  <span class="date">{{ article.publishDate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="ym_layout ym_mt20">
        <img src="/static/img/ershida.jpg" style="width: 1200px;height: 130px;" />
      </div>

      <div class="ym_mt20 ym_ixPart7">
        <div class="ixPart7 text-center">
          <ul class="card-area clearfix">
            <li class="card-item p1 active" style="width: 100%;">
              <div class="card">
                <div class="card-title bold">
                  <i class="icon1 dong"></i>
                  <p>仲裁服务</p>
                </div>
                <div class="card-content">
                  <div v-for="service in services" :key="service.name" class="ym_tp1">
                    <a :href="service.url">
                      <i><img :src="service.icon"></i>
                      <p class="textH">{{ service.name }}</p>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { getApiUrl, API_CONFIG } from '@/api'

export default {
  name: 'Home',
  components: { Footer },
  data() {
    return {
      currentImageIndex: 0,
      currentNewsIndex: 0,
      showCarouselButtons: false,
      showCaseMenu: false,
      casePublicityItems: [
        { name: '调解1部', url: 'http://wztjweb.icag.cn/?bt=syszcw' },
        { name: '调解2部', url: 'http://wztjweb.icag.cn/?bt=sysgl' },
        { name: '调解3部', url: 'http://wztjweb.icag.cn/?bt=sysdl' },
        { name: '调解4部', url: 'http://wztjweb.icag.cn/?bt=syshy' },
      ],
      carouselImages: [
        '/static/img/ban07.jpg',
        '/static/img/ban02.jpg',
        '/static/img/ban09.jpg'
      ],
      sloganText: '<span>独立</span><span>公正</span><span>廉洁</span><span>高效</span>',
      menuItems: [
        { name: '网站首页', path: '/', code: 'HOME', subMenus: [] },
        { name: '关于我们', path: '/about', code: 'GYWM', subMenus: [] },
        { name: '仲裁服务', path: '/serveList', code: 'ZCFW', subMenus: [] },
        { name: '双仲动态', path: '/dynamiList', code: 'SZDT', subMenus: [] },
        { name: '通知公告', path: '/messageList', code: 'TZGG', subMenus: [] }
      ],
      newsSlides: ['/static/img/news.png', '/static/img/ban02.jpg'],
      activeTab: 0,
      szdtArticles: [],
      tzggArticles: [],
      services: [
        { name: '仲裁员查询', url: '/serveList?type=ZCYCX', icon: '/static/img/W020220510745507277006.png' },
        { name: '仲裁费计算', url: '/serveList?type=ZCFJS', icon: '/static/img/W020220510746362567178.png' },
        { name: '立案须知', url: '/serveList?type=LAXZ', icon: '/static/img/W020220510746232471660.png' },
        { name: '在线立案', url: '/serveList?type=WSLAXT', icon: '/static/img/W020220510747175274572.png' },
        { name: '仲裁规则', url: '/serveList?type=ZCGZ', icon: '/static/img/W020220510746523309773.png' },
        { name: '资料下载', url: '/serveList?type=ZLXZ', icon: '/static/img/W020220510747175274572.png' }
      ]
    }
  },
  mounted() {
    this.startCarousel()
    this.startNewsCarousel()
    this.loadSubMenus()
    this.loadNewsData()
    document.addEventListener('click', this.closeCaseMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeCaseMenu)
  },
  methods: {
    startCarousel() {
      setInterval(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.carouselImages.length
      }, 5000)
    },
    startNewsCarousel() {
      setInterval(() => {
        if (this.newsSlides.length > 0) {
          this.currentNewsIndex = (this.currentNewsIndex + 1) % this.newsSlides.length
        }
      }, 5000)
    },
    prevImage() {
      this.currentImageIndex = this.currentImageIndex === 0 
        ? this.carouselImages.length - 1 
        : this.currentImageIndex - 1
    },
    nextImage() {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.carouselImages.length
    },
    switchTab(index) {
      this.activeTab = index
    },
    showAlert() {
      alert('系统维护中')
    },
    toggleCaseMenu() {
      this.showCaseMenu = !this.showCaseMenu
    },
    closeCaseMenu(e) {
      const el = this.$refs.caseBtn
      if (el && !el.contains(e.target)) {
        this.showCaseMenu = false
      }
    },
    showSubMenu(index) {
      // 鼠标悬停显示子菜单的逻辑
    },
    hideSubMenu(index) {
      // 鼠标离开隐藏子菜单的逻辑
    },
    async loadSubMenus() {
      for (let item of this.menuItems) {
        if (item.code && item.code !== 'HOME') {
          try {
            const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_TYPE_LIST, `/${item.code}`))
            const result = await response.json()
            if (result.code === 0 && result.data) {
              item.subMenus = result.data.map(sub => ({
                name: sub.typeName,
                path: `${item.path}?type=${sub.typeCode}`
              }))
            }
          } catch (error) {
            console.error(`加载${item.name}子菜单失败:`, error)
          }
        }
      }
    },
    async loadNewsData() {
      try {
        const [szdtRes, tzggRes, imagesRes] = await Promise.all([
          fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_CONTENT_LIST, '/SZDT_1?pageNum=1&pageSize=20')),
          fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_CONTENT_LIST, '/TZGG_1?pageNum=1&pageSize=20')),
          fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_IMAGE_LIST))
        ])

        const [szdtData, tzggData, imagesData] = await Promise.all([
          szdtRes.json(),
          tzggRes.json(),
          imagesRes.json()
        ])

        if (szdtData.code === 0 && szdtData.data) {
          this.szdtArticles = szdtData.data
        }
        if (tzggData.code === 0 && tzggData.data) {
          this.tzggArticles = tzggData.data
        }
        if (imagesData.code === 0 && imagesData.data && imagesData.data.length > 0) {
          this.newsSlides = imagesData.data.map(img =>
            img.startsWith('http') ? img :
              img.startsWith('data:image') ? img :
                `data:image/jpeg;base64,${img}`
          )
        }
      } catch (error) {
        console.error('加载新闻数据失败:', error)
      }
    }
  }
}
</script>

<style scoped>
@import '../assets/styles.css';
@import '../assets/index.css';

/* 顶部“案件公示”下拉菜单 */
.ym_header .ym_layout,
.ym_header .ym_system {
  overflow: visible;
}

/* 两个胶囊按钮统一为 100px 高，位置与原来保持一致 */
.ym_header .ym_system > .ym_system_name {
  display: inline-block;
  vertical-align: top;
  line-height: 70px;
  margin: 0 40px;
}

.ym_case {
  position: relative;
  display: inline-block;
  vertical-align: top;
  height: 100px;
  margin: 0 40px;
  z-index: 300;
}

.ym_case .ym_case_trigger {
  display: block;
  line-height: 70px;
  margin: 0;
  cursor: pointer;
}

.ym_case_dropdown {
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  min-width: 100%;
  padding: 8px 0;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(18, 93, 178, 0.25);
  line-height: 1.5;
  letter-spacing: 0;
  z-index: 300;
}

.ym_case_item {
  display: block;
  padding: 10px 28px;
  color: #125db2;
  font-size: 22px;
  line-height: 32px;
  letter-spacing: 2px;
  white-space: nowrap;
  text-decoration: none;
  border-radius: 10px;
  transition: background 0.2s, color 0.2s;
}

.ym_case_item:hover {
  background: #125db2;
  color: #fff;
}

.ym_case_fade-enter-active,
.ym_case_fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.ym_case_fade-enter,
.ym_case_fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}
</style>